function nombreErrores() {
    const errors = []
    if (!this.$v.form.nombre.$dirty) return errors;
    !this.$v.form.nombre.required && errors.push('El nombre es obligatorio')
    return errors
}

function apellidoErrores() {
    const errors = []
    if (!this.$v.form.apellidos.$dirty) return errors;
    !this.$v.form.apellidos.required && errors.push('El apellido es obligatorio')
    return errors
}

function tipoDocumentoErrores() {
    const errors = []
    if (!this.$v.form.tipoDocumento.$dirty) return errors
    // !this.$v.form.tipoDocumento.hasTypeOfDocument && errors.push('Especifique el tipo de documento')
    return errors
}

function documentoErrores() {
    const errors = []
    if (!this.$v.form.documento.$dirty) return errors
    // !this.$v.form.documento.validDocument && errors.push(this.form.tipoDocumento + ' no válido')
    // !this.$v.form.documento.identifier && errors.push('Se require al menos un identificador de cliente')
    // !this.$v.form.document.required && errors.push('El ' + this.form.typeof_document + ' es obligatorio')
    return errors
}

function telefonosErrores() {
    const errors = []
    if (!this.$v.form.telefonos.$dirty) return errors;
    return errors
}

function emailErrores() {
    const errors = []
    if (!this.$v.form.email.$dirty) return errors;
    !this.$v.form.email.required && errors.push('Campo obligatorio')
    !this.$v.form.email.email && errors.push('Email no válido')
    // !this.$v.form.email.identifier && errors.push('Se require al menos un identificador de cliente')
    return errors
}

function passwordErrores() {
    const errors = []
    if (!this.$v.form.password.$dirty) return errors
    this.form.password && (!this.$v.form.password.min || !this.$v.form.password.max) && errors.push('La longitud es incorrecta')
    return errors
}

function password2Errores() {
    const errors = []
    if (!this.$v.form.password2.$dirty) return errors
    !this.$v.form.password2.requiredIf && errors.push('Este campo es obligatorio si se ha introducido una contraseña')
    !this.$v.form.password2.sameAs && errors.push('Las contraseñas no coinciden')
    return errors
}

function direccionErrores() {
    const errors = []
    if (!this.$v.form.direccion.$dirty) return errors;
    // !this.$v.form.address.required && errors.push('La dirección es obligatioria')
    return errors
}

function cpErrores() {
    const errors = []
    if (!this.$v.form.cp.$dirty) return errors;
    this.form.cp && (!this.$v.form.cp.min || !this.$v.form.cp.max) && errors.push('Código postal no válido')
    // !this.$v.form.cp.required && errors.push('El código postal es obligatiorio')
    return errors
}

function costoGeneralErrores() {
    const errors = []
    // if (!this.$v.form.costoGeneral.$dirty) return errors
    this.form.costoGeneral && !(this.form.costoGeneral >= 0) && errors.push('El valor no puede ser negativo')
    // !this.$v.form.costoGeneral.required && errors.push('El costo general es obligatorio')
    return errors
}

function NUSSErrores() {
    const errors = []
    if (!this.$v.form.nuss.$dirty) return errors
    this.form.nuss && (!this.$v.form.nuss.min || !this.$v.form.nuss.max) && errors.push('La longitud es incorrecta')
    return errors
}

function IBANErrores() {
    const errors = []
    if (!this.$v.form.iban.$dirty) return errors
    this.form.iban && (!this.$v.form.iban.min || !this.$v.form.iban.max) && errors.push('La longitud es incorrecta')
    return errors
}

function localidadErrores() {
    const errors = []
    if (!this.$v.form.localidad.$dirty) return errors;
    // !this.$v.form.region.required && errors.push('La localidad es obligatioria')
    return errors
}

function usernameErrores() {
    const errors = []
    if (!this.$v.form.username.$dirty) return errors
    !this.$v.form.username.required && errors.push('Este campo es obligatorio')
    return errors
}

function rolErrores() {
    const errors = []
    if (!this.$v.form.rol.$dirty) return errors
    !this.$v.form.rol.required && errors.push('Este campo es obligatorio')
    return errors
}

function tipoComercialErrores() {
    const errors = []
    if (!this.$v.form.tipoComercial.$dirty) return errors
    !this.$v.form.tipoComercial.requiredIf && errors.push('Este campo es obligatorio')
    return errors
}

function estadoErrores() {
    const errors = []
    if (!this.$v.form.estado.$dirty) return errors
    !this.$v.form.estado.required && errors.push('Este campo es obligatorio')
    return errors
}

function telefonoErrores() {
    const errors = []
    // this.$v.form.numerosContacto.$dirty && !this.$v.form.numerosContacto.identifier && errors.push('Se require al menos un telefono de comercial valido')
    // if (!this.$v.form.numerosContacto.$dirty) return errors

    if (!this.$v.telefono.$dirty) {
        return errors;
    }
    if (this.telefono) {
        !this.$v.telefono.validTelefono && errors.push('Teléfono no válido')
    }
    return errors
}

export {
    nombreErrores,
    apellidoErrores,
    tipoDocumentoErrores,
    documentoErrores,
    telefonosErrores,
    emailErrores,
    direccionErrores,
    cpErrores,
    localidadErrores,
    usernameErrores,
    rolErrores,
    tipoComercialErrores,
    NUSSErrores,
    costoGeneralErrores,
    IBANErrores,
    estadoErrores,
    telefonoErrores,
    passwordErrores,
    password2Errores
};
